import { useShouldShowMessagingRoutes } from "@circle-react/hooks/useIsMessagingEnabled";

import { DirectMessagesPopover } from "./DirectMessagesPopover";

export const DirectMessages = () => {
  const { shouldShowMessagingRoutes } = useShouldShowMessagingRoutes();

  if (!shouldShowMessagingRoutes) {
    return null;
  }

  return <DirectMessagesPopover />;
};
